import { css } from 'styled-components';

export default css`
  display: flex;
  flex-direction: column;
  height: 100%;
  .step-content {
    padding: 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    .step-component {
      flex: 1;
    }
    .step-actions {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      gap: 10px;
    }
  }
`;
